import React, { Component } from 'react';
// import VideoPlayer from '../shared/VideoPlayer';

import imgTele2 from '../../../img/tele2.jpg';
import imgTele22x from '../../../img/tele2-2x.jpg';
import imgTele2Tablet from '../../../img/tele2-tablet.jpg';
import imgTele2Mobile from '../../../img/tele2-mobile.jpg';
import imgTele22 from '../../../img/tele2-slider.gif';
import imgTele23 from '../../../img/tele2-slider-2.gif';
import imgTele24 from '../../../img/tele2-emotions.jpg';
import imgCC1 from '../../../img/cavalier-challenge-1.jpg';
import imgCC12x from '../../../img/cavalier-challenge-1-2x.jpg';
import imgCC1Tablet from '../../../img/cavalier-challenge-1-tablet.jpg';
import imgCC1Mobile from '../../../img/cavalier-challenge-1-mobile.jpg';
import imgCC2 from '../../../img/cavalier-challenge-smoke.gif';
import imgCC3 from '../../../img/cavalier-challenge-gameplay.gif';
import imgCC4 from '../../../img/cavalier-challenge-2.jpg';
import imgCC42x from '../../../img/cavalier-challenge-2-2x.jpg';
import imgCC4Tablet from '../../../img/cavalier-challenge-2-tablet.jpg';
import imgCC4Mobile from '../../../img/cavalier-challenge-2-mobile.jpg';
import imgRluijtenPhotography from '../../../img/rluijten-photography.jpg';
import imgRluijtenPhotography2x from '../../../img/rluijten-photography-2x.jpg';
import imgRluijtenPhotographyTablet from '../../../img/rluijten-photography-tablet.jpg';
import imgRluijtenPhotographyMobile from '../../../img/rluijten-photography-mobile.jpg';
import imgGeneralElectric from '../../../img/general-electric.jpg';
import imgGeneralElectric2x from '../../../img/general-electric-2x.jpg';
import imgGeneralElectricTablet from '../../../img/general-electric-tablet.jpg';
import imgGeneralElectricMobile from '../../../img/general-electric-mobile.jpg';
import imgFoam from '../../../img/foam.jpg';
import imgFoam2x from '../../../img/foam-2x.jpg';
import imgFoamTablet from '../../../img/foam-tablet.jpg';
import imgFoamMobile from '../../../img/foam-mobile.jpg';
import imgMammut from '../../../img/mammut.jpg';
import imgMammut2x from '../../../img/mammut-2x.jpg';
import imgMammutTablet from '../../../img/mammut-tablet.jpg';
import imgMammutMobile from '../../../img/mammut-mobile.jpg';
// import imgDisney from '../../../img/disney.jpg';
// import imgDisney2x from '../../../img/disney-2x.jpg';
// import imgDisneyTablet from '../../../img/disney-tablet.jpg';
// import imgDisneyMobile from '../../../img/disney-mobile.jpg';
import imgColumbia100 from '../../../img/columbia-100.jpg';
import imgColumbia1002x from '../../../img/columbia-100-2x.jpg';
import imgColumbia100Tablet from '../../../img/columbia-100-tablet.jpg';
import imgColumbia100Mobile from '../../../img/columbia-100-mobile.jpg';
import imgBMW from '../../../img/bmw-usa.jpg';
import imgBMW2x from '../../../img/bmw-usa-2x.jpg';
import imgBMWTablet from '../../../img/bmw-usa-tablet.jpg';
import imgBMWMobile from '../../../img/bmw-usa-mobile.jpg';
import imgExoApe from '../../../img/exo-ape.jpg';
import imgExoApe2x from '../../../img/exo-ape-2x.jpg';
import imgExoApeTablet from '../../../img/exo-ape-tablet.jpg';
import imgExoApeMobile from '../../../img/exo-ape-mobile.jpg';
import imgWrk from '../../../img/wrk.jpg';
import imgWrk2x from '../../../img/wrk-2x.jpg';
import imgWrkTablet from '../../../img/wrk-tablet.jpg';
import imgWrkMobile from '../../../img/wrk-mobile.jpg';

import data from '../../../json/data.json';

// eslint-disable-next-line
class Projects extends Component {
  render() {
    const projects = data[1].projects;

    return (
      <section className="projects">
        <div className="container">
          <div className="project">
            {/*
              <h2 className="project__subtitle">{projects.cc.role}</h2>
            */}
            <h1 className="project__title">{projects.cc.title}</h1>
            <picture>
              <source srcSet={imgCC1Mobile} media="(max-width: 480px)" />
              <source srcSet={imgCC1Tablet} media="(max-width: 768px)" />
              <source srcSet={imgCC12x} media="(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)" />
              <source srcSet={imgCC1} />
              <img src={imgCC1} className="project__image" alt="Cavalier Challenge" />
            </picture>
            <img src={imgCC2} className="project__image project__image--50" alt="Cavalier Challenge" />
            <img src={imgCC3} className="project__image project__image--50" alt="Cavalier Challenge" />
            <picture>
              <source srcSet={imgCC4Mobile} media="(max-width: 480px)" />
              <source srcSet={imgCC4Tablet} media="(max-width: 768px)" />
              <source srcSet={imgCC42x} media="(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)" />
              <source srcSet={imgCC4} />
              <img src={imgCC4} className="project__image" alt="Cavalier Challenge" />
            </picture>
            <div className="project__description">
              <p className="project__description__block">{projects.cc.description1}</p>
              <p className="project__description__block">{projects.cc.description2}</p>
              <p className="project__description__block">{projects.cc.description3}</p>
            </div>

            <h4 className="project__awards__title">Awards</h4>
            <ul className="project__awards">
              <li className="project__award">
                <span className="project__award__text"><strong>FWA</strong> Site of the Day</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>FWA</strong> Adobe Cutting Edge Award</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Site of the Day</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Developer Award</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Site of the Year (Innovative / Experimental)</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>CSS Design Awards</strong> Site of the Day</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>CSS Design Awards</strong> Site of the Year (Best Game Site / Interactive)</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>W3 Awards</strong> Experimental, Siliver</span>
              </li>
            </ul>
          </div>

          <div className="project">
            <h1 className="project__title">{projects.wrk.title}</h1>
            <picture>
              <source srcSet={imgWrkMobile} media="(max-width: 480px)" />
              <source srcSet={imgWrkTablet} media="(max-width: 768px)" />
              <source srcSet={imgWrk2x} media="(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)" />
              <source srcSet={imgWrk} />
              <img src={imgWrk} className="project__image" alt="WRK Timepieces" />
            </picture>
            <div className="project__description">
              <p className="project__description__block">{projects.wrk.description1}</p>
            </div>

            <h4 className="project__awards__title">Awards</h4>
            <ul className="project__awards">
              <li className="project__award">
                <span className="project__award__text"><strong>FWA</strong> Site of the Day</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Site of the Day</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Developer Award</span>
              </li>
            </ul>

            <a
              href={projects.wrk.link}
              className="project__anchor-link" target="_blank"
              rel="noopener noreferrer"
            >
              Visit website <span className="project__anchor-link--arrow">→</span>
            </a>
          </div>

          <div className="project">
            <h1 className="project__title">{projects.mammut.title}</h1>
            <picture>
              <source srcSet={imgMammutMobile} media="(max-width: 480px)" />
              <source srcSet={imgMammutTablet} media="(max-width: 768px)" />
              <source srcSet={imgMammut2x} media="(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)" />
              <source srcSet={imgMammut} />
              <img src={imgMammut} className="project__image" alt="Mammut" />
            </picture>
            <div className="project__description">
              <p className="project__description__block">{projects.mammut.description1}</p>
            </div>

            <h4 className="project__awards__title">Awards</h4>
            <ul className="project__awards">
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Site of the Day</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Developer Award</span>
              </li>
            </ul>

            <a
              href={projects.mammut.link}
              className="project__anchor-link" target="_blank"
              rel="noopener noreferrer"
            >
              Visit website <span className="project__anchor-link--arrow">→</span>
            </a>
          </div>

          <div className="project">
            <h1 className="project__title">{projects.exoApe.title}</h1>
            <picture>
              <source srcSet={imgExoApeMobile} media="(max-width: 480px)" />
              <source srcSet={imgExoApeTablet} media="(max-width: 768px)" />
              <source srcSet={imgExoApe2x} media="(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)" />
              <source srcSet={imgExoApe} />
              <img src={imgExoApe} className="project__image" alt="Mammut" />
            </picture>
            <div className="project__description">
              <p className="project__description__block">{projects.exoApe.description1}</p>
            </div>

            <h4 className="project__awards__title">Awards</h4>
            <ul className="project__awards">
              <li className="project__award">
                <span className="project__award__text"><strong>FWA</strong> Site of the Day</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Site of the Day</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Site of the Month</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Developer Award</span>
              </li>
            </ul>

            <a
              href={projects.exoApe.link}
              className="project__anchor-link" target="_blank"
              rel="noopener noreferrer"
            >
              Visit website <span className="project__anchor-link--arrow">→</span>
            </a>
          </div>

          <div className="project">
            <h1 className="project__title">{projects.columbia100.title}</h1>
            <picture>
              <source srcSet={imgColumbia100Mobile} media="(max-width: 480px)" />
              <source srcSet={imgColumbia100Tablet} media="(max-width: 768px)" />
              <source srcSet={imgColumbia1002x} media="(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)" />
              <source srcSet={imgColumbia100} />
              <img src={imgColumbia100} className="project__image" alt="Columbia Pictures lady" />
            </picture>
            <div className="project__description">
              <p className="project__description__block">{projects.columbia100.description1}</p>
            </div>

            <h4 className="project__awards__title">Awards</h4>
            <ul className="project__awards">
              <li className="project__award">
                <span className="project__award__text"><strong>FWA</strong> Site of the Day</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Site of the Day</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Developer Award</span>
              </li>
            </ul>

            <a
              href={projects.columbia100.link}
              className="project__anchor-link" target="_blank"
              rel="noopener noreferrer"
            >
              Visit website <span className="project__anchor-link--arrow">→</span>
            </a>
          </div>

          <div className="project">
            <h1 className="project__title">{projects.general_electric.title}</h1>
            <picture>
              <source srcSet={imgGeneralElectricMobile} media="(max-width: 480px)" />
              <source srcSet={imgGeneralElectricTablet} media="(max-width: 768px)" />
              <source srcSet={imgGeneralElectric2x} media="(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)" />
              <source srcSet={imgGeneralElectric} />
              <img src={imgGeneralElectric} className="project__image" alt="General Electric - Innovation Barometer 2020" />
            </picture>
            <div className="project__description">
              <p className="project__description__block">{projects.general_electric.description1}</p>
            </div>

            <h4 className="project__awards__title">Awards</h4>
            <ul className="project__awards">
              <li className="project__award">
                <span className="project__award__text"><strong>FWA</strong> Site of the Day</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Site of the Day</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Developer Award</span>
              </li>
            </ul>

            <a
              href={projects.general_electric.link}
              className="project__anchor-link" target="_blank"
              rel="noopener noreferrer"
            >
              Visit website <span className="project__anchor-link--arrow">→</span>
            </a>
          </div>

          <div className="project">
            <h1 className="project__title">{projects.foam.title}</h1>
            <picture>
              <source srcSet={imgFoamMobile} media="(max-width: 480px)" />
              <source srcSet={imgFoamTablet} media="(max-width: 768px)" />
              <source srcSet={imgFoam2x} media="(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)" />
              <source srcSet={imgFoam} />
              <img src={imgFoam} className="project__image" alt="Foam - Photography museum" />
            </picture>
            <div className="project__description">
              <p className="project__description__block">{projects.foam.description1}</p>
            </div>

            <h4 className="project__awards__title">Awards</h4>
            <ul className="project__awards">
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Site of the Day</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Developer Award</span>
              </li>
            </ul>

            <a
              href={projects.foam.link}
              className="project__anchor-link" target="_blank"
              rel="noopener noreferrer"
            >
              Visit website <span className="project__anchor-link--arrow">→</span>
            </a>
          </div>

          <div className="project">
            <h1 className="project__title">{projects.bmwusa.title}</h1>
            <picture>
              <source srcSet={imgBMWMobile} media="(max-width: 480px)" />
              <source srcSet={imgBMWTablet} media="(max-width: 768px)" />
              <source srcSet={imgBMW2x} media="(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)" />
              <source srcSet={imgBMW} />
              <img src={imgBMW} className="project__image" alt="BMW USA" />
            </picture>
            <div className="project__description">
              <p className="project__description__block">{projects.bmwusa.description1}</p>
              <p className="project__description__block">{projects.bmwusa.description2}</p>
            </div>

            <h4 className="project__awards__title">Awards</h4>
            <ul className="project__awards">
              <li className="project__award">
                <span className="project__award__text"><strong>J.D. Power</strong> Number 1 Automotive Website</span>
              </li>
            </ul>

            <a href={projects.bmwusa.link} className="project__anchor-link" target="_blank" rel="noopener noreferrer">Visit website <span className="project__anchor-link--arrow">→</span></a>
          </div>

          <div className="project">
            <h1 className="project__title">{projects.rluijten_photography.title}</h1>
            <picture>
              <source srcSet={imgRluijtenPhotographyMobile} media="(max-width: 480px)" />
              <source srcSet={imgRluijtenPhotographyTablet} media="(max-width: 768px)" />
              <source srcSet={imgRluijtenPhotography2x} media="(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)" />
              <source srcSet={imgRluijtenPhotography} />
              <img src={imgRluijtenPhotography} className="project__image" alt="Ruud Luijten Photography" />
            </picture>
            <div className="project__description">
              <p className="project__description__block">{projects.rluijten_photography.description1}</p>
              <p className="project__description__block">{projects.rluijten_photography.description2}</p>
            </div>

            <h4 className="project__awards__title">Awards</h4>
            <ul className="project__awards">
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Site of the Day</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Developer Award</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>CSS Design Awards</strong> Site of the Day</span>
              </li>
            </ul>

            <a
              href={projects.rluijten_photography.link}
              className="project__anchor-link" target="_blank"
              rel="noopener noreferrer"
            >
              Visit website <span className="project__anchor-link--arrow">→</span>
            </a>
          </div>

          {/* <div className="project">
            <h1 className="project__title">{projects.nieuw_bergen.title}</h1>
            <picture>
              <source srcSet={imgNieuwBergenMobile} media="(max-width: 480px)" />
              <source srcSet={imgNieuwBergenTablet} media="(max-width: 768px)" />
              <source srcSet={imgNieuwBergen2x} media="(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)" />
              <source srcSet={imgNieuwBergen} />
              <img src={imgNieuwBergen} className="project__image" alt="Nieuw Bergen - Iconic Living" />
            </picture>
            <div className="project__description">
              <p className="project__description__block">{projects.nieuw_bergen.description1}</p>
              <p className="project__description__block">{projects.nieuw_bergen.description2}</p>
            </div>

            <h4 className="project__awards__title">Awards</h4>
            <ul className="project__awards">
              <li className="project__award">
                <span className="project__award__text"><strong>FWA</strong> Site of the Day</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Site of the Day</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>Awwwards</strong> Developer Award</span>
              </li>
              <li className="project__award">
                <span className="project__award__text"><strong>CSS Design Awards</strong> Site of the Day</span>
              </li>
            </ul>

            <a
              href={projects.nieuw_bergen.link}
              className="project__anchor-link" target="_blank"
              rel="noopener noreferrer"
            >
              Visit website <span className="project__anchor-link--arrow">→</span>
            </a>
          </div> */}

          <div className="project">
            <h1 className="project__title">{projects.tele2.title}</h1>
            <picture>
              <source srcSet={imgTele2Mobile} media="(max-width: 480px)" />
              <source srcSet={imgTele2Tablet} media="(max-width: 768px)" />
              <source srcSet={imgTele22x} media="(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)" />
              <source srcSet={imgTele2} />
              <img src={imgTele2} className="project__image" alt="Tele2 - Settle for more" />
            </picture>
            <img src={imgTele22} className="project__image project__image--50" alt="Cavalier Challenge" />
            <img src={imgTele23} className="project__image project__image--50" alt="Cavalier Challenge" />
            <picture>
              <source srcSet={imgTele24} media="(max-width: 480px)" />
              <source srcSet={imgTele24} media="(max-width: 768px)" />
              <source srcSet={imgTele24} media="(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)" />
              <source srcSet={imgTele24} />
              <img src={imgTele24} className="project__image" alt="Tele2 - Settle for more" />
            </picture>
            <div className="project__description">
              <p className="project__description__block">{projects.tele2.description1}</p>
              <p className="project__description__block">{projects.tele2.description2}</p>
              <p className="project__description__block">{projects.tele2.description3}</p>
            </div>

            <a
              href={projects.tele2.link}
              className="project__anchor-link" target="_blank"
              rel="noopener noreferrer"
            >
              View case study <span className="project__anchor-link--arrow">→</span>
            </a>
          </div>
        </div>
      </section>
    );
  }
}

export default Projects;



// WEBPACK FOOTER //
// ./client/js/components/projects/Projects.js